<template>
  <div class="ipro2 clearfix">
    <div class="headx">
      <h2>
        <em> 
          <b>客户</b>案例
        </em>
        <span></span>
      </h2>
      <a href="/xueyuan" class="mo">MORE+</a>
    </div>
    <div class="tod">
      <ul>
        <li v-for="(item, index) in nowData" :key="index">
          <a class="img" :href="'/xueyuan_in?id=' + item.id" :title="item.title">
            <img :src="http + item.attachfile" :alt="item.title" :title="item.title" />
          </a>
          <div class="wd">
            <a :href="'/xueyuan_in?id=' + item.id" :title="item.title">{{item.title}}</a>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import method from "@/utils/Untitl.js";
export default {
  data() {
    return {
      isDesktop: window.innerWidth > 428,
      http: process.env.VUE_APP_BASE_API,
      nowData: [],
    };
  },
  mounted() {
    // 监听窗口大小变化
    window.addEventListener("resize", this.handleResize);
    this.getIpro();
  },
  beforeDestroy() {
    // 移除事件监听器
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    handleResize() {
      // 根据窗口宽度更新 isDesktop 状态
    },
    async getIpro() {
      const res = await method.index();
      if (res.code == 1) {
        this.nowData = res.data.xy;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/pc/index_ipro.scss";
@import "@/assets/css/move/index_ipro.scss";
</style>
<style scoped>
.img >>> img {
  
}
</style>